const styles = (theme) => ({
  container: {
    padding: theme.spacing(1.5, 0),
    minWidth: '100%',
    paddingLeft: theme.spacing(1),
  },
  paper: {
    maxWidth: 600,
    margin: 'auto',

    '&> ul': {
      maxHeight: 'initial',
    },
  },
  option: {
    padding: theme.spacing(2, 4),
  },
});

export default styles;
